export default __webpack_public_path__ + "media/mock/src/img/logo_amex-3181be3ad3df6d228b53136a1a296653.png";